module.exports = __webpack_public_path__ + "img/gates.88ddce86.png";